export default "__VITE_ASSET__81d659de__"